<template>
    <section
        class="pricing section"
        :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]">
        <div class="container">
            <div
                class="pricing-inner section-inner"
                :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]">
                <!-- <c-section-header :data="sectionHeader" class="center-content invert-color" /> -->
                <!-- <div
                    v-if="pricingSwitcher"
                    class="pricing-switcher center-content"
                >
                    <c-switch
                        v-model="priceChangerValue"
                        true-value="1"
                        false-value="0"
                        right-label="Billed Annually">
                        Billed Monthly
                    </c-switch>
                </div> -->
                <div
                    v-if="pricingSlider"
                    class="pricing-slider center-content"
                >
                    <label class="form-slider">
                        <span class="mb-16">How many users do you have?</span>
                        <input
                            type="range"
                            ref="slider"
                            v-model="priceChangerValue"
                            @input="handlePricingSlide"
                            />
                        </label>
                    <div ref="sliderValue" class="pricing-slider-value">
                        {{ getPricingData(priceInput) }}
                    </div>
                </div>                
                <div
                    class="tiles-wrap illustration-section-07"
                    :class="[
                        pushLeft && 'push-left',
                    ]">
                    <div class="tiles-item reveal-scale-up">
                        <div class="tiles-item-inner has-shadow">
                            <div class="pricing-item-content">
                                <div class="pricing-item-header pb-16 mb-24">
                                    <!-- <div class="pricing-item-price mb-4">
                                        <span class="pricing-item-price-currency h2 text-color-low">{{ getPricingData(this.priceOutput.plan1, 0) }}</span>
                                        <span class="pricing-item-price-amount h1">{{ getPricingData(this.priceOutput.plan1, 1) }}</span>
                                    </div> -->
                                    <div class="text-color-low text-xs" style="font-size:30px;">
                                        澳洲中国线路
                                        <c-image
                                        class="pricing-item-icon"
                                        :src="require('@/assets/images/ems.png')"
                                        alt="Diamond"
                                        :width="90"
                                        :height="80" />
                                    </div>
                                </div>
                                <div class="pricing-item-features mb-40">
                                    <div class="pricing-item-features-title fw-500 text-xs text-color-high mb-24">
                                        What's included
                                    </div>
                                    <ul class="pricing-item-features-list list-reset text-xs mb-32">
                                        <li class="is-checked">1、2段奶粉3罐</li>
                                        <li class="is-checked">3、4段/成人奶粉/3罐</li>
                                        <li class="is-checked">成人奶粉6袋</li>
                                        <li class="is-checked">化妆品/保健品/杂货/零食(内件物品总数&lt;=8个且总价值&lt;$100)</li>
                                  
                                    </ul>
                                </div>
                            </div>
                            <div class="pricing-item-cta mb-8">
                                <c-button tag="a" color="primary" wide href="#"><router-link to="/contact/" style="color:white;">联系我们</router-link></c-button>
                            </div>
                        </div>
                    </div>

                    <div class="tiles-item reveal-scale-up" data-reveal-delay="200">
                        <div class="tiles-item-inner has-shadow">
                            <div class="pricing-item-content">
                                <div class="pricing-item-header pb-16 mb-24">
                                    <!-- <div class="pricing-item-price mb-4">
                                        <span class="pricing-item-price-currency h2 text-color-low">{{ getPricingData(this.priceOutput.plan2, 0) }}</span>
                                        <span class="pricing-item-price-amount h1">{{ getPricingData(this.priceOutput.plan2, 1) }}</span>
                                    </div> -->
                                    <!-- <div class="text-color-low text-xs" style="margin-top:-15px;">
                                        <img width="60" height="30" style="float:left" :src="require('@/assets/images/xmt.png')"/>
                                        <img width="60" height="30" style="float:left;margin-left:40px;" :src="require('@/assets/images/Singapore.png')"/>
                                        <img width="60" height="30" style="margin-left:200px;" :src="require('@/assets/images/Taiwan.png')"/>
                                    </div> -->
                                    <div class="text-color-low text-xs" style="font-size:30px;">
                                    新马台专线
                                    <c-image
                                        class="pricing-item-icon"
                                        style="margin-top:-20px;"
                                        :src="require('@/assets/images/xmt.png')"
                                        alt="Diamond"
                                        :width="100"
                                        :height="80" />
                                    </div>
                                </div>
                                <div class="pricing-item-features mb-40">
                                    <div class="pricing-item-features-title fw-500 text-xs text-color-high mb-24">
                                        What's included
                                    </div>
                                    <ul class="pricing-item-features-list list-reset text-xs mb-32">
                                        <li class="is-checked">新加坡专线</li>
                                        <li class="is-checked">马来西亚专线</li>
                                        <li class="is-checked">台湾专线</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="pricing-item-cta mb-8">
                                <c-button tag="a" color="secondary" wide href="#"><router-link to="/contact/" style="color:white;">联系我们</router-link></c-button>
                            </div>
                        </div>
                    </div>

                    <div class="tiles-item reveal-scale-up" data-reveal-delay="400">
                        <div class="tiles-item-inner has-shadow">
                            <div class="pricing-item-content">
                                <div class="pricing-item-header pb-16 mb-24">
                                    <!-- <div class="pricing-item-price mb-4">
                                        <span class="pricing-item-price-currency h2 text-color-low">{{ getPricingData(this.priceOutput.plan3, 0) }}</span>
                                        <span class="pricing-item-price-amount h1">{{ getPricingData(this.priceOutput.plan3, 1) }}</span>
                                    </div> -->
                                    <div class="text-color-low text-xs" style="font-size:30px;">
                                       澳洲邮政
                                       <c-image
                                        class="pricing-item-icon"
                                        style="margin-top:-10px;"
                                        :src="require('@/assets/images/aupost.png')"
                                        alt="Diamond"
                                        :width="100"
                                        :height="80" />
                                    </div>
                                </div>
                                <div class="pricing-item-features mb-40">
                                    <div
                                        class="pricing-item-features-title fw-500 text-xs text-color-high mb-24">
                                        What's included
                                    </div>
                                    <ul class="pricing-item-features-list list-reset text-xs mb-32">
                                        <li class="is-checked">Australia Domestic澳大利亚境内</li>
                                        <li class="is-checked">International国际件</li>
                                        <li class="is-checked">Standard标准件</li>
                                        <li class="is-checked">Express快件</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="pricing-item-cta mb-8">
                                <c-button tag="a" color="primary" wide href="#"><router-link to="/contact/" style="color:white;">联系我们</router-link></c-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { SectionTilesProps } from '@/utils/SectionProps.js'
// import CSectionHeader from '@/components/sections/partials/SectionHeader.vue'
// import CSwitch from '@/components/elements/Switch.vue'
import CButton from '@/components/elements/Button.vue'
import CImage from '@/components/elements/Image.vue'

export default {
  name: 'CPricing',
  components: {
    // CSectionHeader,
    // CSwitch,
    CButton,
    CImage
  },
  mixins: [SectionTilesProps],
  props: {
    pricingSwitcher: {
      type: Boolean,
      default: false
    },
    pricingSlider: {
      type: Boolean,
      default: false
    }        
  },
  data() {
    return {
    //   sectionHeader: {
    //     title: 'Simple pricing',
    //     paragraph: ''
    //   },
      priceChangerValue: "1",
      priceInput: {
        // 0: "1,000",
        // 1: "1,250"
      },
      priceOutput: {
        plan1: {
          0: ["$", "55", "monthly"],
          1: ["$", "47", "annually"]
        },
        plan2: {
          0: ["$", "75", "monthly"],
          1: ["$", "67", "annually"]
        },
        plan3: {
          0: ["$", "109", "monthly"],
          1: ["$", "97", "annually"]
        }
      }
    }
  },
  methods: {    
    handlePricingSlide(e) {
      this.handleSliderValuePosition(e.target)
    },
    handleSliderValuePosition(input) {
      const multiplier = input.value / input.max
      const thumbOffset = this.thumbSize * multiplier
      const priceInputOffset = (this.thumbSize - this.$refs.sliderValue.clientWidth) / 2
      this.$refs.sliderValue.style.left = input.clientWidth * multiplier - thumbOffset + priceInputOffset + 'px'
    },
    getPricingData(values, set) {
      return set !== undefined ? values[this.priceChangerValue][set] : values[this.priceChangerValue]
    }
  },
  mounted() {
    if (this.pricingSlider) {
      this.$refs.slider.setAttribute('min', 0)
      this.$refs.slider.setAttribute('max', Object.keys(this.priceInput).length - 1)
      this.thumbSize = parseInt(window.getComputedStyle(this.$refs.sliderValue).getPropertyValue('--thumb-size'), 10)
      this.handleSliderValuePosition(this.$refs.slider)
    }        
  }
}
</script>